import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Retry: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={18}
      height={15}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.5 2.5a1 1 0 102 0 1 1 0 00-2 0zm1-2.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-5 1.75a5.25 5.25 0 100 10.5h3.796l-1.29 1.29 1.06 1.062 3.066-3.066L9.066 8.47l-1.06 1.06 1.219 1.22H5.5a3.75 3.75 0 110-7.5H6v-1.5h-.5zm10 10.75a1 1 0 110-2 1 1 0 010 2zm-2.5-1a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z'
        fill='currentColor'
      />
    </svg>
  </i>
);

Retry.displayName = 'Retry';
export default Retry;
